export const templates = ['url', 'pdf', 'link-list', 'app', 'images', 'vcard-plus', 'social', 'coupon', 'video'];
